import { mapActions, mapGetters } from 'vuex';


export default {
    data() {
        return {
            scrollLockHelperStyleProp: 'paddingRight',
        };
    },
    computed: {
        ...mapGetters(['scroll']),
        scrollLockStyles() {
            return {
                [this.scrollLockHelperStyleProp]: (this.scroll.isLocked ? `${ this.scroll.scrollbarWidth }px` : ''),
            };
        },
    },
    methods: {
        ...mapActions(['lockScroll']),
        onScrollLockEnterHook() {
            this.lockScroll({ isLocked: true });
        },
        onScrollLockAfterLeaveHook() {
            this.lockScroll({ isLocked: false });
        },
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/mixins/scroll-lock-helper/index.js